import React from "react";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import CopyToClipboard from "../../lib/common/components/CopyToClipboard";
import PropTypes from "prop-types";

const ShareLinkModal = ({ isOpen, onClose, sharedLink, chatId }) => {
  return (
    <Dialog onClose={onClose} open={isOpen} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ paddingBottom: "0" }}>Share link</DialogTitle>
      <DialogContent className="max-h-[400px] overflow-y-auto px-16 mt-2">
        <Typography>
          Your name, custom instructions, and any messages you add after sharing
          stay private.
        </Typography>
        <div className="flex items-center mt-4 mb-8 border rounded-lg px-3 py-2 ">
          <span
            className="truncate text-gray-900 text-sm flex-1"
            title="https://dabur.com/share/how can a warehouse impl..."
          >
            {sharedLink}
          </span>
          <CopyToClipboard
            message={sharedLink}
            id={chatId}
            isCopyButton={true}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};


ShareLinkModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sharedLink: PropTypes.string.isRequired,
  chatId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ShareLinkModal;
